import { get, post } from '@/api/client';
import type { PmsAccessResponse, PmsStopResult } from './types';

const base = (practiceId: string) => `/api/rcm/v1/practices/${practiceId}/settings`;

/** The word the stop switch asks for. A confirmation that can be clicked
 *  through is not one, so this is not "yes". */
export const STOP_CONFIRMATION = 'STOP';

export const pmsAccessApi = {
  status: (practiceId: string) => get<PmsAccessResponse>(`${base(practiceId)}/pms-access`),

  /** Write-only. The password goes to the vault; nothing reads it back. */
  storeCredential: (
    practiceId: string,
    body: { kind: string; label: string; secret: string; username?: string }
  ) =>
    post<{ label: string; kind: string; status: string }>(
      `${base(practiceId)}/pms-access/credential`,
      body
    ),

  /** Stops reading and destroys the credentials. Terminal. */
  stop: (practiceId: string, reason: string) =>
    post<PmsStopResult>(`${base(practiceId)}/pms-access/stop`, {
      confirm: STOP_CONFIRMATION,
      reason,
    }),
};
